import { render, staticRenderFns } from "./SystemTime.vue?vue&type=template&id=2398ed8b&"
import script from "./SystemTime.vue?vue&type=script&lang=js&"
export * from "./SystemTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports